import React, { useEffect, useState } from 'react';
import { useLocation, Link } from "react-router-dom";
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Loader from '../../components/loader';

function App() {

  const location = useLocation();
  const { payment, year, month } = location?.state || [];
  const [loading, setLoading] = useState(false);
  const [ledgers, setLedger] = useState([]);

  const getLedger = async () => {
	try {
		const response = await axios.get("https://api.trucoo.in/ledger/", {
			headers: {
				"Content-Type": "application/json",
				"X-API-KEY": "erpTrucoo",
			},
		});

		if (response.data.status === "success") {
			setLedger(response.data.data);
		}
	} catch (error) {
		console.error(error);
	}
  };

  useEffect(() => {
        getLedger();
  },[]);

  const getAllDaysOfMonth = (year, month) => {
    const daysInMonth = new Date(year, month, 0).getDate();

    const pad = (n) => String(n).padStart(2, "0");

    return Array.from({ length: daysInMonth }, (_, i) => {
        const day = i + 1;
        return `${year}-${pad(month)}-${pad(day)}`;
    });
  };


  const dateRange = getAllDaysOfMonth(year, month);

  const months = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "long" })
  );

  const getDataByDate = (data, date) => data?.filter(item => item?.date === date) || [];

  const getTotalSales = (data) => {
    let total = 0;
    data.forEach((item) => {
      total += Number(item?.totalPayment || 0);
    });
    return total;
  };

  const getTotalReceipts = (data) => {
    let total = 0;
    data.forEach((item) => {
      total += Number(item?.receipt_amount || 0);
    });
    return total;
  };

  const getTotalBank = (data) => {
    let total = 0;
    data.forEach((item) => {
      total += Number(item?.amount || 0);
    });
    return total;
  };

  const getCDnote = (data) => {
    let creditTotal = 0;
    let debitTotal = 0;
    data?.forEach((item) => {
      if(item?.type === 'credit'){
        creditTotal += Number(item?.amount || 0);
      }else if(item?.type === 'debit'){
        debitTotal += Number(item?.amount || 0);
      }
    });
    return {creditTotal, debitTotal};
  };

  const obSales = getTotalSales(payment?.obInvoices);
  const obReceipts = getTotalReceipts(payment?.obReceipts);
  const sales = getTotalSales(payment?.invoices);
  const receipts = getTotalReceipts(payment?.receipts);
  const {creditTotal, debitTotal} = getCDnote(payment?.cdNotes || []);
  const { creditTotal: obCreditTotal, debitTotal: obDebitTotal } = getCDnote(payment?.obCDNotes || []);
  const bankCollection = getTotalBank(payment?.bankCollection || []);
  const oBbankCollection = getTotalBank(payment?.obBankCollection || []);

  const openingBalance = (obSales + obCreditTotal) - ( obReceipts + obDebitTotal + oBbankCollection);
  const closingBal = openingBalance + ((sales + debitTotal) - (receipts + creditTotal + bankCollection));

  function getFiscalYearLabel(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth(); 
    if (month < 3) {
        return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
    } else {
        return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
    }
  };

  const getLedgerDetails = (data) => {

		let  returnData = '';

		if(data?.master){
			const master = ledgers?.filter(ledg => ledg.id === data?.master)[0];
			const masterName = master?.masterName;
			// returnData += masterName;

			if(data?.mainGroup){
				const account = master?.main?.filter(acc => acc.id === data?.mainGroup)[0];
				const accountName = account?.mainGroupName;
				// returnData += ` / ${accountName}`;
			
				if(data?.subGroup){
					const ledger = account?.sub?.filter(ledg => ledg.id === data?.subGroup)[0]; 
					const ledgerName = ledger?.subGroupName;
					returnData += `${ledgerName}`;
				}
			}
		}

		return returnData;
	};

  let debitTotalValue = Number(openingBalance);
  let creditTotalValue = 0;

  return (
    <>
     {loading && <Loader />}
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="col-12">
              <div className="box">
                <div className="box-header with-border">
                   <h6 className="text-center ">Party Ledger Data of <span className='text-bold text-primary fs-22'>{payment?.dealer} </span>{dateRange[0] } to { dateRange[dateRange.length -1] }</h6>
                </div>
                <div className="box-body">
                  
                  <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 310px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                    <table className="table-sm fs-12 text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                      <thead>
                         <tr className="text-dark text-center" style={{ position: 'sticky', top: -1, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                        
                          <th className='text-center'>Date</th>
                          <th className='text-center'>Type</th>
                          <th >Particulars</th>
                          <th className='text-center'>Vch Type</th>
                          <th>NARRATION</th>
                          <th className='text-end'>Debit</th>
                          <th className='text-end'>Credit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td colSpan={4}></td>
                            <th className='text-center'>Opening Balance</th>
                            <th className='text-end'>{Number(openingBalance).toFixed(2)}</th>
                            <td></td>
                        </tr>
                          {dateRange?.map((date, index) => {

                            const invoices = getDataByDate(payment?.invoices, date);
                            const receipts = getDataByDate(payment?.receipts, date);
                            const cdNotes = getDataByDate(payment?.cdNotes, date);
                            const bankCollect = getDataByDate(payment?.bankCollection, date);

                            const rows = [];

                            bankCollect.forEach(rec => {
                                const ledger = getLedgerDetails(rec);
                                creditTotalValue += Number(rec?.amount || 0);
                                rows.push(
                                    <tr key={`rec-${index}`}>
                                        <td className='text-center'>{date}</td>
                                        <td className='text-center'>Cr</td>
                                        <td className='text-center'>{ledger}</td>
                                        <td className='text-center'>Receipt</td>
                                        <td className='text-center'>Bank Collection</td>
                                        <td></td>
                                        <td className='text-end'>{Number(rec?.amount || 0).toFixed(2)}</td>
                                    </tr>
                                );
                            });

                            invoices.forEach(inv => {
                                debitTotalValue += Number(inv?.totalPayment || 0);
                                rows.push(
                                    <tr key={`inv-${index}`}>
                                        <td className='text-center'>{date}</td>
                                        <td className='text-center'>Dr</td>
                                        <td className='text-center'>GST SALES</td>
                                        <td className='text-center'>Sales</td>
                                        <td className='text-center'>TRC/{inv?.invoiceId}/{getFiscalYearLabel(new Date(inv?.date))}</td>
                                        <td className='text-end'>{Number(inv?.totalPayment || 0).toFixed(2)}</td>
                                        <td></td>
                                    </tr>
                                );
                            });

                            receipts.forEach(rec => {
                                const ledger = getLedgerDetails(rec);
                                creditTotalValue += Number(rec?.receipt_amount || 0);
                                rows.push(
                                    <tr key={`rec-${index}`}>
                                        <td className='text-center'>{date}</td>
                                        <td className='text-center'>Cr</td>
                                        <td className='text-center'>{ledger}</td>
                                        <td className='text-center'>Receipt</td>
                                        <td className='text-center'></td>
                                        <td></td>
                                        <td className='text-end'>{Number(rec?.receipt_amount || 0).toFixed(2)}</td>
                                    </tr>
                                );
                            });

                            cdNotes.forEach(note => {
                                const amount = Number(note?.amount || 0);
                                const type = note?.type;
                                if(amount > 0) {

                                    type === 'credit' ? debitTotalValue += amount : creditTotalValue += amount;
                                    const ledger = getLedgerDetails(note);
                                    rows.push(
                                        <tr key={`cd-${index}-${type}`}>
                                            <td className='text-center'>{date}</td>
                                            <td className='text-center'>{type === 'credit' ? 'Cr' : 'Dr'}</td>
                                            <td className='text-center'>{type === 'credit' ? 'CREDIT NOTE' : ledger}</td>
                                            <td></td>
                                            <td className='text-center'>{type} note</td>
                                            {type === 'credit' ?
                                                <>
                                                    <td className='text-end'>{amount.toFixed(2)}</td>
                                                    <td></td>
                                                </>
                                              : 
                                              <>
                                                <td></td>
                                                <td className='text-end'>{amount.toFixed(2)}</td>
                                              </>
                                            }
                                        </tr>
                                    );
                                }
                            });

                            return rows.length > 0 ? rows : null;
                        })}
                            <tr
                            className="text-dark"
                            style={{
                                position: "sticky",
                                bottom: -11,
                                zIndex: 2,
                                backgroundColor: "#f8f9fa",
                            }}>
                                <td colSpan={5}></td>
                                <th className='text-end'>{Number(debitTotalValue).toFixed(2)}</th>
                                <th className='text-end'>{Number(creditTotalValue).toFixed(2)}</th>
                            </tr>
                      </tbody>
                    </table>
                  </div>

                  <h6 className='mt-2 fw-500 text-end p-4'>Closing Balance : {Number(debitTotalValue - creditTotalValue).toFixed(2)} </h6>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default App;
